import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PriceCalculatorPanel from '../../components/calculator/PriceCalculatorPanel';

function CalculatorPage() {
    const navigate = useNavigate();

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to="/admin">
                    Dashboard
                </Link>
                <Typography color="text.primary">Calculadora de preço</Typography>
            </Breadcrumbs>
            <Box sx={{ my: 2 }} />
            <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', fontWeight: 700 }}>
                Calculadora de preços 3D
            </Typography>
            <PriceCalculatorPanel
                variant="admin"
                intro="Multiparte, embalagem, marketplace e maquininha no mesmo cálculo — para decidir preço mínimo e margem real antes de fechar o pedido."
            />
        </div>
    );
}

export default CalculatorPage;
